import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import CaseStudiesSection from "@/sections/CaseStudiesSection";
import Testimonials from "@/sections/Testimonials";
import CTABanner from "@/components/CTABanner";

export default function CaseStudiesPage() {
  return (
    <>
      <SEO
        title="Case Studies — Proven Results"
        description="See how DiziTeQ solved real business challenges with measurable results — more bookings, lower cost per lead and higher rankings for Bengaluru businesses."
        path="/case-studies"
      />
      <PageHeader
        eyebrow="Case studies"
        title="The problems we solved and the"
        highlight="results we delivered"
        subtitle="Deep dives into how we turn business challenges into growth, backed by real numbers."
      />
      <CaseStudiesSection showHeader={false} />
      <Testimonials />
      <div className="py-10"><CTABanner /></div>
    </>
  );
}
